import React from "react";
import Style from "../Style/AdminSidebar.module.scss";
import {
  MdAddPhotoAlternate,
  MdPhotoLibrary,
  MdRateReview,
  MdStar,
  MdCategory,
  MdViewList,
  MdMoreHoriz,
} from "react-icons/md";

const AdminSidebar = ({ isOpen, setActiveTab, activeTab }) => {
  const menuItems = [
    {
      label: "Add Gallery Image",
      icon: <MdAddPhotoAlternate />,
      tab: "add-image",
    },
    {
      label: "View Gallery Image",
      icon: <MdPhotoLibrary />,
      tab: "view-image",
    },
    {
      label: "Add Testimonial",
      icon: <MdRateReview />,
      tab: "add-testimonials",
    },
    {
      label: "View Testimonials",
      icon: <MdViewList />,
      tab: "add-testimonialsView",
    },
    { label: "Add Course", icon: <MdStar />, tab: "add Course" },
    { label: "View Course", icon: <MdViewList />, tab: "add CourseView" },
    { label: "Add Subcategory", icon: <MdCategory />, tab: "add-subcategory" },
    {
      label: "View Subcategory",
      icon: <MdViewList />,
      tab: "add-subcategoryview",
    },
    {
      label: "Add categoryMore",
      icon: <MdMoreHoriz />,
      tab: "add-SubcategoryMore",
    },
    {
      label: "SubcategoryMore",
      icon: <MdMoreHoriz />,
      tab: "add-SubcategoryMoreView",
    },
  ];

  return (
    <div className={`${Style.sidebar} ${isOpen ? Style.open : ""}`}>
      <h3 className={Style.sidebarTitle}>Admin Panel</h3>
      <div className={Style.menu}>
        {menuItems.map((item) => (
          <button
            key={item.tab}
            onClick={() => setActiveTab(item.tab)}
            className={activeTab === item.tab ? Style.active : ""}
          >
            <span className={Style.icon}>{item.icon}</span>
            {item.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default AdminSidebar;
